import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DismissNotificationsByNoteMutation,
  DismissNotificationsByNoteMutationVariables,
} from "./DismissNotificationsByNote.generated";

export const DISMISS_NOTIFICATIONS_BY_NOTE: TypedDocumentNode<
  DismissNotificationsByNoteMutation,
  DismissNotificationsByNoteMutationVariables
> = gql`
  mutation dismissNotificationsByNote(
    $noteUuid: String!
    $notificationType: String!
  ) {
    dismissNotificationsByNote(
      noteUuid: $noteUuid
      notificationType: $notificationType
    ) {
      ok
    }
  }
`;
